import { queryOptions } from '@tanstack/react-query';

import { QUERY_STALE_TIME } from '@/constants/queryDefaults';

import { catalogApi } from './catalog.api';

export const catalogOptions = {
  spot: () =>
    queryOptions({
      queryKey: ['spotCatalog'] as const,
      queryFn: catalogApi.getSpotCatalog,
      refetchOnWindowFocus: false,
      staleTime: QUERY_STALE_TIME.standard
    }),
  forward: () =>
    queryOptions({
      queryKey: ['forwardCatalog'] as const,
      queryFn: catalogApi.getForwardCatalog,
      refetchOnWindowFocus: false,
      staleTime: QUERY_STALE_TIME.standard
    })
};
